export default __webpack_public_path__ + "static/media/046-Al shaheed.a77fa837.svg";